import logo from '@~assets/logo/logo.gif';

export const Logo = () => {
  return <img src={logo} width={150} alt="Aurous Finance" />;
};
